import React from "react";
import yogaImg from "../assets/life.webp";
import { useNavigate } from "react-router-dom";
import Testimonials from "./Testimonials";
import SocialLinks from "./SocialLinks";

// Import the VIP guest images
import NammalvarImg from "../assets/nammalvar.webp";
import WigneswaranImg from "../assets/wigneswaran.webp";
import PalaninedumaranImg from "../assets/palaneduaran.webp";
import dharmapuraadeenam from "../assets/dharmapuraadeenam.webp"
import DietImg from "../assets/services/Diet.webp";
import Fasting from "../assets/services/Fasting.webp";
import Yoga from "../assets/services/yoga.webp";

function Home() {
  const navigate = useNavigate();
  
  return (
    <>
      {/* 1. HERO SECTION: Welcome & Quick Action Buttons */}
      <section className="w-full bg-gradient-to-br from-green-50 via-white to-green-100 py-12 md:py-20 px-6 md:px-16 min-h-screen font-poppins flex items-center">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center w-full">

          {/* Left Side: Solid Text Content */}
          <div className="flex flex-col text-left space-y-6">
            <span className="text-green-700 bg-green-100 font-extrabold text-sm uppercase tracking-widest px-4 py-1.5 rounded-full w-fit">
              🌿 Nature Cure & Yoga Centre
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-neutral-900 leading-tight">
              Natural Healing <br />
              <span className="text-green-700">For Better Living</span>
            </h1>

            <p className="text-neutral-900 text-base sm:text-lg lg:text-xl font-extrabold leading-relaxed max-w-xl">
              Universal Goodlife Ashram is a 100% natural healing sanctuary. Experience complete rejuvenation through raw living foods, drugless naturopathy therapies, and peaceful yogic lifestyles.
            </p>

            {/* Main Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={() => window.location.href = "tel:+919443043074"}
                className="bg-green-700 hover:bg-green-800 text-white px-8 py-4 rounded-2xl text-lg font-bold shadow-lg hover:shadow-xl transition duration-300 flex items-center justify-center gap-2"
              >
                📞 Call Now
              </button>

              <button
                onClick={() => window.open("https://wa.me/919443043074?text=Hi%20I%20want%20to%20book%20an%20appointment", "_blank")}
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-2xl text-lg font-bold shadow-lg hover:shadow-xl transition duration-300 flex items-center justify-center gap-2"
              >
                💬 WhatsApp
              </button>
            </div>
          </div>

          {/* Right Side: Main Ashram Framed Photo */}
          <div className="relative flex justify-center items-center">
            <div className="absolute top-10 right-10 w-72 h-72 bg-green-200/50 rounded-full blur-2xl z-0" />
            <div className="relative z-10 overflow-hidden rounded-[2.5rem] shadow-2xl border-4 border-white bg-white max-w-md lg:max-w-full">
              <img
                src={yogaImg}
                alt="Universal Goodlife Ashram"
                loading="eager"
                fetchPriority="high"
                className="w-full h-auto object-cover max-h-[500px]"
              />
            </div>
          </div>

        </div>
      </section>

      {/* 2. CORE SERVICES SHOWCASE */}
      <section className="w-full bg-white py-16 px-6 md:px-16 font-poppins border-t border-green-100">
        <div className="max-w-7xl mx-auto text-center">
          <span className="text-green-600 font-extrabold text-sm uppercase tracking-widest">Our Treatments</span>
          <h2 className="text-3xl md:text-5xl font-black text-neutral-900 mt-2 mb-12">Natural Therapies We Provide</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-green-50/70 p-8 rounded-3xl border border-green-200 text-left shadow-md hover:scale-105 transition duration-300">
              <div>
                <div className="w-full h-48 overflow-hidden rounded-2xl mb-5 border border-green-100 relative">
                  <img
                    src= {DietImg}
                    alt="Diet Therapy"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <div className="text-4xl mb-4">🥗</div></div>
                <h3 className="text-2xl font-bold text-green-900 mb-2">Diet Therapy</h3>
                <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                  100% natural raw diet with different varieties of Fruits, Vegetables, Salads, Sprouts and Juices. These are useful for healing and promoting health.
                </p>
              </div>
            </div>
            {/* Card 2 */}
            <div className="bg-green-50/70 p-8 rounded-3xl border border-green-200 text-left shadow-md hover:scale-105 transition duration-300">
              <div>
                <div className="w-full h-48 overflow-hidden rounded-2xl mb-5 border border-green-100 relative">
                  <img
                    src= {Fasting}
                    alt="Fasting Therapy"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <div className="text-4xl mb-4">⏳</div></div>
                <h3 className="text-2xl font-bold text-green-900 mb-2">Fasting Therapy</h3>
                <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                  Fasting gives rest to the digestive system. During fasting only water and simple juices are given. It helps purification of body and mind and improves natural healing.
                </p>
              </div></div>
            {/* Card 3 */}
            <div className="bg-green-50/70 p-8 rounded-3xl border border-green-200 text-left shadow-md hover:scale-105 transition duration-300">
              <div>
                <div className="w-full h-48 overflow-hidden rounded-2xl mb-5 border border-green-100 relative">
                  <img
                    src={Yoga}
                    alt="Yoga Therapy"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <div className="text-4xl mb-4">🧘</div></div>
                <h3 className="text-2xl font-bold text-green-900 mb-2">Yoga Therapy</h3>
                <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                  Includes yoga asanas, pranayama, meditation, relaxation methods and yogic kriyas.
                </p>
              </div></div>
          </div>

          <button
            onClick={() => navigate("/services")}
            className="mt-10 bg-green-700 hover:bg-green-800 text-white font-bold text-lg px-10 py-4 rounded-xl transition duration-300 shadow-lg"
          >
            Explore All Services &rarr;
          </button>
        </div>
      </section>

      {/* 3. VIP / PROMINENT PERSONALITIES SHOWCASE */}
      <section className="w-full bg-neutral-50 py-16 px-6 md:px-16 font-poppins border-t border-b border-neutral-200">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="text-green-600 font-extrabold text-sm uppercase tracking-widest block mb-2">
              Respected Endorsements
            </span>
            <h2 className="text-2xl md:text-4xl font-black text-neutral-900 mb-4">
              Eminent Personalities at Our Ashram
            </h2>
            <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
              We have been blessed with visits from revered leaders who advocate for sustainable, toxic-free organic life.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8"> */}
            {/* VIP 1 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-neutral-200 p-5 shadow-md hover:shadow-xl transition duration-300">
              <img src={NammalvarImg} alt="G. Nammalvar" loading="lazy" className="w-full h-52 object-cover rounded-2xl mb-4" />
              <h4 className="text-2xl font-bold text-green-900 mb-2">G. Nammalvar</h4>
              <p className="text-xs font-bold text-green-700 uppercase tracking-wider mb-3">
                Organic Farming Scientist
              </p>
              <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                Visited our space to observe, support, and appreciate our raw food nutrition systems.
              </p>
            </div>

            {/* VIP 2 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-neutral-200 p-5 shadow-md hover:shadow-xl transition duration-300">
              <img src={WigneswaranImg} alt="C. V. Wigneswaran" loading="lazy" className="w-full h-52 object-cover rounded-2xl mb-4" />
              <h4 className="text-2xl font-bold text-green-900 mb-2">C. V. Wigneswaran</h4>
              <p className="text-xs font-bold text-green-700 uppercase tracking-wider mb-3">
                Former CM, Northern Province SL
              </p>
              <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                Experienced our healing natural lifestyle atmosphere firsthand during his visit.
              </p>
            </div>

            {/* VIP 3 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-neutral-200 p-5 shadow-md hover:shadow-xl transition duration-300">
              <img src={PalaninedumaranImg} alt="Palaninedumaran" loading="lazy" className="w-full h-52 object-cover rounded-2xl mb-4" />
              <h4 className="text-2xl font-bold text-green-900 mb-2">Pazha Nedumaran</h4>
              <p className="text-xs font-bold text-green-700 uppercase tracking-wider mb-3">
                Prominent Tamil Leader
              </p>
              <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                Interacted closely with practitioners and observed the efficacy of the treatments.
              </p>
            </div>
            {/* VIP 4 */}
            <div className="bg-white rounded-3xl overflow-hidden border border-neutral-200 p-5 shadow-md hover:shadow-xl transition duration-300">
              <img src={dharmapuraadeenam} alt="dharmapuraadeenam" loading="lazy" className="w-full h-52  rounded-2xl mb-4" />
              <h4 className="text-2xl font-bold text-green-900 mb-2">Paramacharya Swamigal</h4>
              <p className="text-xs font-bold text-green-700 uppercase tracking-wider mb-3">
                {/* Changed "Prominent Tamil Leader" to actual title */}
                Dharmapuram Adheenam
              </p>
              <p className="text-neutral-900 text-[16px] font-extrabold leading-relaxed">
                Blessed our center with his presence and observed the natural healing methods.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. ACCOMMODATION & ACCOMPANIED STAY INFORMATION */}
      <section className="w-full bg-gradient-to-b from-white to-green-50 py-16 px-6 md:px-16 font-poppins border-t border-green-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

            {/* Text side */}
            <div className="space-y-6 text-left">
              <span className="text-green-600 font-extrabold text-sm uppercase tracking-widest">Peaceful Accommodation</span>
              <h2 className="text-3xl md:text-5xl font-black text-neutral-900 leading-tight">
                Ashram Rooms & Facilities
              </h2>
              <p className="text-neutral-900 text-[17px] font-extrabold leading-relaxed">
                We offer a highly secure, clean, and peaceful environment setup for long-term health stays and dynamic recovery routines. Complete comfort meets natural green living.
              </p>

              <ul className="space-y-4 text-neutral-900 font-black text-[16px]">
                <li className="flex items-center gap-2">🏡 Clean, Well-Ventilated Private Cottage Rooms</li>
                <li className="flex items-center gap-2">🍃 Quiet, Serene Nature and Mountain View Surroundings</li>
                <li className="flex items-center gap-2">💧 Pure Mineral Rich Drinking Water Supply</li>
                <li className="flex items-center gap-2">💡 24/7 Hot Water and Uninterrupted Backup Power System</li>
              </ul>

              <button
                onClick={() => navigate("/room")}
                className="inline-block bg-white border-2 border-green-700 text-green-800 font-bold text-lg px-8 py-4 rounded-xl hover:bg-green-50 transition duration-300 shadow-md mt-4"
              >
                View Room Gallery & Details
              </button>
            </div>

            {/* Quick Graphic Card Block */}
            <div className="bg-white p-6 rounded-[2.5rem] shadow-2xl border border-green-200">
              <div className="bg-gradient-to-br from-green-900 to-green-800 rounded-[1.8rem] p-12 text-center flex flex-col items-center justify-center min-h-[350px]">
                <span className="text-7xl mb-4">🏠</span>
                <h3 className="text-3xl font-black text-white">Your Home in Nature</h3>
                <p className="text-green-100 text-base font-bold mt-3 max-w-sm leading-relaxed">
                  A perfect, pollution-free destination in Universal Good Life Ashram to completely heal your body, rest your mind, and revive your soul.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 4. EXTENSION COMPONENTS */}
      <Testimonials />
      {/* <VideoSection /> */}
      <SocialLinks />
    </>
  );
}

export default Home;